import type { RecordOutcome } from '@sportninja/common/features/competition/operations/utils/recordBarSegments'

/**
 * Colour scale for the five in-division outcomes, running good → bad.
 *
 * These are NOT arbitrary categorical hues and NOT tenant-switched: the five
 * outcomes carry a fixed meaning (a win is a win on both tenants), so the scale
 * is a semantic one, like the status palette. It is deliberately close to the
 * SUCCESS / INFO / WARNING / ERROR ramps in appColors but re-stepped for
 * colour-blind separation against the panel's dark surface (SECONDARY_400).
 *
 * Validated with the dataviz palette checker against #1b222b: lightness band,
 * chroma floor, adjacent CVD separation (worst pair ΔE 12.0 under
 * deuteranopia) and the normal-vision floor (17.1) all pass. Re-run that check
 * before changing any value here.
 *
 * Colour is never the only channel — every row prints its record as text, and
 * each segment carries a <title> for hover.
 */
export const RECORD_COLORS: Record<RecordOutcome, string> = {
  wins: '#2f9e49',
  losses: '#c02020',
  ties: '#3894ff',
  otLosses: '#ab8600',
  soLosses: '#d96a8f',
}
